import type { RouteRecordRaw } from "vue-router";

export const screenRecorderRoutes: RouteRecordRaw[] = [
  {
    path: "/screen_recorder/info",
    name: "screen_recorder-info",
    component: () => import("./info/ScreenRecorderInfoPage.vue"),
    meta: {
      namespace: "screen_recorder",
      title: "tools_meta.screen_recorder_prefix",
    },
  },
  {
    path: "/screen_recorder/files",
    name: "screen_recorder-index",
    component: () => import("./files/ScreenRecordingListPage.vue"),
    meta: {
      requiresAuth: true,
      namespace: "screen_recorder",
      title: "tools_meta.screen_recorder_prefix",
    },
  },
  {
    path: "/screen_recorder/files/:id",
    name: "screen_recorder-show",
    component: () => import("./files/ScreenRecordingLayout.vue"),
    meta: {
      requiresAuth: true,
      namespace: "screen_recorder",
      title: "tools_meta.screen_recorder_prefix",
    },
    children: [
      {
        path: "settings",
        name: "screen_recorder-settings",
        component: () => import("./files/[id]/settings.vue"),
        meta: {
          requiresAuth: true,
          namespace: "screen_recorder",
          title: "tools_meta.screen_recorder_prefix",
        },
      },
      {
        path: "share",
        name: "screen_recorder-share",
        component: () => import("./files/[id]/share.vue"),
        meta: {
          requiresAuth: true,
          namespace: "screen_recorder",
          title: "tools_meta.screen_recorder_prefix",
        },
      },
    ],
  },
  {
    path: "/screen_recorder/public_files/:id",
    name: "screen_recorder-public-show",
    component: () =>
      import("./public_files/[id]/PublicScreenRecordingPage.vue"),
    meta: {
      namespace: "screen_recorder",
      title: "tools_meta.screen_recorder_prefix",
    },
  },
];
